import {State} from "./state";

export class RecentSearch {
  dateCreated: string;
  cusip: string;
  state: State;
  keywords: string;

  constructor(keywords: string, stateId: string, cusip: string) {
    this.keywords = keywords;
    this.state = new State();
    this.state.stateId = Number( stateId);
    this.cusip = cusip;
  }
}
